import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    signal,
    WritableSignal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LegalUrl } from '@interfaces';
import { AppUserService, LegalService } from '@services';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';

interface LegalItem {
    name: string;
    url: string;
    isChecked: WritableSignal<boolean>;
}

@Component({
    selector: 'app-legal-acceptance-dialog',
    imports: [FormsModule, CheckboxModule, ButtonModule],
    templateUrl: './legal-acceptance-dialog.component.html',
    styleUrl: './legal-acceptance-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalAcceptanceDialogComponent {
    protected readonly user = inject(AppUserService).data;
    protected readonly legalService = inject(LegalService);
    protected readonly isAcceptButtonLoading = signal(false);

    protected readonly isAllLegalItemsChecked = computed(() =>
        this.legalItems.every((item) => item.isChecked())
    );

    protected readonly legalItems: LegalItem[] = [
        {
            name: 'Terms of Service',
            url: this.legalUrl.tos,
            isChecked: signal(false)
        },
        {
            name: 'Privacy Policy',
            url: this.legalUrl.pp,
            isChecked: signal(false)
        },
        {
            name: 'Acceptable Use Policy',
            url: this.legalUrl.aup,
            isChecked: signal(false)
        }
    ];

    private get legalUrl(): LegalUrl {
        return this.legalService.url;
    }

    protected async onAcceptButtonClick(): Promise<void> {
        this.isAcceptButtonLoading.set(true);
        await this.legalService.acceptTermsAndPolicies();
        this.isAcceptButtonLoading.set(false);
    }
}
